import { Playlist } from '../types/catalog'

export const catalog: Playlist[] = [
  {
    title: 'T-Pain',
    thumbnail: {
      url: '/img/nas1Archive/tpain_2024.jpg',
      width: 1200,
      height: 800,
    },
    sequences: [
      {
        title: 'On This Hill',
        author: 'T-Pain',
        maxTrisPerFrame: 3000,
        textureResolution: 480,
        scenes: [
          {
            comment: 'T-Pain - 480p quality',
            desktop4DS: '/4ds/OnThisHill_R03_SNAP_15FPS_3kTris_MS4tx/OnThisHill_R03_SNAP_15FPS_3kTris_MS4tx_480pDESKTOP.4ds',
            mobile4DS: '/4ds/OnThisHill_R03_SNAP_15FPS_3kTris_MS4tx/OnThisHill_R03_SNAP_15FPS_3kTris_MS4tx_480p.4ds',
          },
        ],
      },
      {
        title: 'On This Hill (4k tris version)',
        author: 'T-Pain',
        maxTrisPerFrame: 4000,
        textureResolution: 480,
        scenes: [
          {
            comment: 'T-Pain - 480p quality',
            desktop4DS: '/4ds/OnThisHill_R03_SNAP_MS4kTris_15FPS_MS4tx/OnThisHill_R03_SNAP_MS4k_15FPS_MS4tx_480pDESKTOP.4ds',
            mobile4DS: '/4ds/OnThisHill_R03_SNAP_MS4kTris_15FPS_MS4tx/OnThisHill_R03_SNAP_MS4k_15FPS_MS4tx_480p.4ds',
          },
        ],
      },
    ],
  },
  {
    title: 'Yelawolf',
    thumbnail: {
      url: '/img/staging_s3/yelawolf.jpg',
      width: 1200,
      height: 800,
    },
    sequences: [
      {
        title: 'You And Me',
        author: 'Yelawolf',
        maxTrisPerFrame: 3500,
        textureResolution: 480,
        scenes: [
          {
            comment: 'Yelawolf - 480p quality',
            desktop4DS: '/4ds/Yela_YouAndME_SNAP_R01/Yela_YouAndMe_SNAP_3p5kTris_MS5Tx_r01_480pDesktop.4ds',
            mobile4DS: '/4ds/Yela_YouAndME_SNAP_R01/Yela_YouAndMe_SNAP_3p5kTris_MS5Tx_r01_480p.4ds',
          },
        ],
      },
    ],
  },
  {
    title: 'Uncle Lazer\'s Comedy Special',
    thumbnail: {
      url: '/img/nas1Archive/uncle_lazer.jpg',
      width: 1200,
      height: 800,
    },
    sequences: [
      {
        title: "Introduction - First 4 minutes.",
        author: 'Uncle Lazer',
        maxTrisPerFrame: 3500,
        textureResolution: 480,
        scenes: [
          {
            comment: 'Uncle Lazer - 480p quality',
            desktop4DS: '/4ds/UncleLazer_ComedySpecialIntro_SNAP_15FPS_3p5kTris_MS5tx_SNAPR01/UncleLazer_ComedySpecialIntro_SNAP_15FPS_3p5kTris_MS5tx_SNAPR01_480pDESKTOP.4ds',
            mobile4DS: '/4ds/UncleLazer_ComedySpecialIntro_SNAP_15FPS_3p5kTris_MS5tx_SNAPR01/UncleLazer_ComedySpecialIntro_SNAP_15FPS_3p5kTris_MS5tx_SNAPR01_480p.4ds',
          },
        ],
      },
    ],
  },
]
